// 常用币种配置
export const CURRENCY_OPTIONS = [
  {
    code: 'CNY',
    name: '人民币',
    symbol: '¥',
    nameEn: 'Chinese Yuan',
    nameRu: 'Китайский юань',
    nameTh: 'หยวนจีน',
    nameDe: 'Chinesischer Yuan'
  },
  {
    code: 'USD',
    name: '美元',
    symbol: '$',
    nameEn: 'US Dollar',
    nameRu: 'Доллар США',
    nameTh: 'ดอลลาร์สหรัฐ',
    nameDe: 'US-Dollar'
  },
  {
    code: 'EUR',
    name: '欧元',
    symbol: '€',
    nameEn: 'Euro',
    nameRu: 'Евро',
    nameTh: 'ยูโร',
    nameDe: 'Euro'
  },
  {
    code: 'JPY',
    name: '日元',
    symbol: '¥',
    nameEn: 'Japanese Yen',
    nameRu: 'Японская иена',
    nameTh: 'เยนญี่ปุ่น',
    nameDe: 'Japanischer Yen'
  },
  {
    code: 'GBP',
    name: '英镑',
    symbol: '£',
    nameEn: 'British Pound',
    nameRu: 'Британский фунт',
    nameTh: 'ปอนด์อังกฤษ',
    nameDe: 'Britisches Pfund'
  },
  {
    code: 'KRW',
    name: '韩元',
    symbol: '₩',
    nameEn: 'South Korean Won',
    nameRu: 'Южнокорейская вона',
    nameTh: 'วอนเกาหลีใต้',
    nameDe: 'Südkoreanischer Won'
  },
  {
    code: 'THB',
    name: '泰铢',
    symbol: '฿',
    nameEn: 'Thai Baht',
    nameRu: 'Тайский бат',
    nameTh: 'บาทไทย',
    nameDe: 'Thailändischer Baht'
  },
  {
    code: 'RUB',
    name: '俄罗斯卢布',
    symbol: '₽',
    nameEn: 'Russian Ruble',
    nameRu: 'Российский рубль',
    nameTh: 'รูเบิลรัสเซีย',
    nameDe: 'Russischer Rubel'
  },
  {
    code: 'SGD',
    name: '新加坡元',
    symbol: 'S$',
    nameEn: 'Singapore Dollar',
    nameRu: 'Сингапурский доллар',
    nameTh: 'ดอลลาร์สิงคโปร์',
    nameDe: 'Singapur-Dollar'
  },
  {
    code: 'HKD',
    name: '港币',
    symbol: 'HK$',
    nameEn: 'Hong Kong Dollar',
    nameRu: 'Гонконгский доллар',
    nameTh: 'ดอลลาร์ฮ่องกง',
    nameDe: 'Hongkong-Dollar'
  }
];

// 根据语言获取币种名称
export const getCurrencyName = (currency, language = 'zh') => {
  if (!currency) return '';
  
  switch (language) {
    case 'en':
      return currency.nameEn;
    case 'ru':
      return currency.nameRu;
    case 'th':
      return currency.nameTh;
    case 'de':
      return currency.nameDe;
    default:
      return currency.name;
  }
};

// 根据币种代码获取币种信息
export const getCurrencyByCode = (code) => {
  return CURRENCY_OPTIONS.find(currency => currency.code === code);
};